// src/router/new-tip-v2.js
//
// Routes Vue Router du module New TIP v2, incluses dans src/routes.js :
//
//   import newTipV2Routes from './router/new-tip-v2';
//   const routes = [...newTipV2Routes, ...];
//
// Convention de `meta` : celle réellement appliquée par les guards de
// routes.js, à savoir { title, permissions }. Les clés `layout`,
// `requiresAuth` et `roles` utilisées par le router v1 ne sont lues par aucun
// guard du projet — inutile de les reprendre ici.
//
// `permissions` est volontairement absent : comme en v1, ces écrans sont
// protégés par le seul contrôle d'authentification global. Pour les réserver
// à un rôle, ajouter ici le libellé exact d'une permission de la table
// `permissions` (ex. ['Voir la page campagnes']).

const newTipV2Routes = [
  {
    path: '/admin/new-tip-v2',
    redirect: { name: 'new-tip-v2.dashboard' },
  },
  {
    path: '/admin/new-tip-v2/dashboard',
    name: 'new-tip-v2.dashboard',
    component: () => import('@/views/new-tip-v2/Dashboard.vue'),
    meta: { title: 'Dashboard New TIP v2' },
  },
  {
    path: '/admin/new-tip-v2/campaigns',
    name: 'new-tip-v2.campaigns.index',
    component: () => import('@/views/new-tip-v2/CampaignsList.vue'),
    meta: { title: 'Campagnes New TIP v2' },
  },
  {
    path: '/admin/new-tip-v2/campaigns/create',
    name: 'new-tip-v2.campaigns.create',
    component: () => import('@/views/new-tip-v2/CampaignForm.vue'),
    meta: { title: 'Nouvelle campagne v2' },
  },
  {
    path: '/admin/new-tip-v2/campaigns/:id',
    name: 'new-tip-v2.campaigns.show',
    component: () => import('@/views/new-tip-v2/CampaignDetail.vue'),
    props: true,
    meta: { title: 'Détail campagne v2' },
  },
  {
    path: '/admin/new-tip-v2/campaigns/:id/edit',
    name: 'new-tip-v2.campaigns.edit',
    component: () => import('@/views/new-tip-v2/CampaignForm.vue'),
    props: true,
    meta: { title: 'Modifier campagne v2' },
  },
  {
    path: '/admin/new-tip-v2/campaigns/:id/assignments',
    name: 'new-tip-v2.campaigns.assignments',
    component: () => import('@/views/new-tip-v2/AssignmentsManager.vue'),
    props: true,
    meta: { title: 'Affectations v2' },
  },
  {
    path: '/admin/new-tip-v2/visits/:id',
    name: 'new-tip-v2.visits.show',
    component: () => import('@/views/new-tip-v2/VisitDetail.vue'),
    props: true,
    meta: { title: 'Détail visite v2' },
  },
];

export default newTipV2Routes;
